import lunr from 'lunr';
import terms from './terms';
require("lunr-languages/lunr.stemmer.support")(lunr);
require("lunr-languages/lunr.es")(lunr);


const MAX_RESULTS = 25;

/**
 * termsIndex starts as null to make it lighter on import.
 * If a function uses termsIndex, it must initialize it first.
 * Around 1ms to initialize.
 **/
let termsIndex = null;

const initIndex = () => {
    if (!termsIndex) {
        termsIndex = lunr(function() {
            this.use(lunr.es);
            this.ref('name');
            this.field('name');
            this.field('definition');
            terms.forEach(doc => {this.add(doc)}, this);
        });
    }
};

const filterFirstLettersWithResults = letter => terms
    .some(term => term.name[0].toLowerCase() === letter.toLowerCase());

const searchByQuery = query => {
    if (!termsIndex) initIndex();
    return termsIndex
        .search(`name:*${query}*^2 ${query}`) // Match is twice as strong for names.
        .slice(0, MAX_RESULTS - 1) // Truncate results.
        .map((result) => result.ref);
};

const searchByFirstLetter = letter => terms
    .filter(term => term.name[0].toLowerCase() === letter.toLowerCase()) // Search straight on the terms object.
    .slice(0, MAX_RESULTS - 1) // Truncate results.
    .map(term => term.name);

const selectResult = result => {
    if (!termsIndex) initIndex();
    return terms.find(term => term.name === result);
};


export {
    filterFirstLettersWithResults,
    searchByQuery,
    searchByFirstLetter,
    selectResult,
};
